import { Col, Form } from "react-bootstrap";
import { getDaysInMonth } from "date-fns";

export default function Day({ controlId, defaultValue, month, year, isValid, onChange }) {
  const daysInMonth = getDaysInMonth(new Date(year, parseInt(month) - 1));

  return (
    <Form.Group as={Col} controlId={controlId}>
      <Form.Control
        as="select"
        data-hj-allow
        isInvalid={isValid !== undefined && !isValid}
        value={defaultValue}
        onChange={onChange}
      >
        {Array.from({ length: daysInMonth }, (_, i) => {
          return (
            <option key={i} value={`${i + 1}`}>
              {i + 1}
            </option>
          );
        })}
      </Form.Control>
    </Form.Group>
  );
}
